import { useEffect, useState } from 'react';
import type { SelectableGroupMember } from '../../components/FilterOrSelectBottomSheet/types';
import { checkIsAvailable } from '../../utils/helperFunctions';
import { fetchAllGroupMembers } from '../../api/groups';

export enum MemberNotMemberGroupsFilters {
  MemberOfGroup,
  NotMemberOfGroup,
}

export const MemberNotMemberFiltersTX: Record<MemberNotMemberGroupsFilters, string> = {
  0: 'messages_groups_where_member',
  1: 'messages_groups_where_not_member',
};

export const useGetMembers = (props: {
  id: number;
  setUserIds?: (set: Set<number>) => void;
  tenantId?: number;
}) => {
  const { id, setUserIds, tenantId } = props;

  const [isGettingMembers, setIsLoading] = useState<boolean>(false);

  const [members, setMembers] = useState<SelectableGroupMember[]>([]);

  const init = async () => {
    if (!id || !tenantId) {
      return;
    }

    setIsLoading(true);
    const groupMembers = await fetchAllGroupMembers({ groupId: id, tenantId });
    const selectableUser = groupMembers.map(member => {
      return {
        ...member,
        name: member.userName,
        imageName: member.photoFileName ?? undefined,
        id: +member.userID,
        showAvailability: !checkIsAvailable(member.unavailableDateTo),
      };
    });
    const selectedGroupMembers = new Set(groupMembers.map(member => member.userID));
    if (setUserIds) setUserIds(selectedGroupMembers);
    setMembers(selectableUser);
    setIsLoading(false);
  };

  useEffect(() => {
    init();
  }, [id]);

  return {
    members,
    isGettingMembers,
  };
};
